module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-edit-b92ebe32b78617fd7285744e86c8f87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-edit.jpg
// module id = 345
// module chunks = 2